import axios from 'axios';

interface Address {
    country: string;
    state: string;
    city: string;
    zip_code: string;
    line_1: string;
}

class CepService {
    private static readonly BASE_URL = 'https://brasilapi.com.br/api/cep/v2/';

    public static async getAddress(zipcode: string): Promise<Address> {
        try {
            const response = await axios.get(`${this.BASE_URL}${zipcode}`);
            const data = response.data;

            const address: Address = {
                country: 'BR',  // BrasilAPI sempre retorna endereços no Brasil
                state: data.state,
                city: data.city,
                zip_code: data.cep,
                line_1: data.street,
            }

            return address;
        } catch (error) {
            const address: Address = {
                country: 'BR',  // BrasilAPI sempre retorna endereços no Brasil
                state: '',
                city: '',
                zip_code: '',
                line_1: '',
            }

            return address;
        }
    }
}


export default CepService
